export const status = ['-','не вырезано', 'вырезано'];

export const NOT_DONE_STATUS = 1;
export const DONE_STATUS = 2;